<template>
  <div class="form">
    <form-field type="email"
                label="Email"
                :validate="/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i"
                :required="true"
                v-model="email"
                :focus="step === 'email'"
                @submit="step = 'password'">
    </form-field>
    <form-field type="password"
                label="Password"
                :required="true"
                v-model="password"
                :focus="step === 'password'"
                @submit="submit">
    </form-field>
    <form-button pull="right" color="blue" @click="submit">Confirm</form-button>
    <form-links>
      <router-link :to="`/reset/${email}`">Reset password</router-link>
      <router-link :to="`/signup/${email}`">Create account</router-link>
    </form-links>
  </div>
</template>

<script>
import { sanitizePassword } from '@/rules';

import FormButton from '../elements/FormButton';
import FormField from '../elements/FormField';
import FormLinks from '../elements/FormLinks';

export default {
  components: {
    FormButton,
    FormField,
    FormLinks,
  },

  data() {
    return {
      step: 'email',
      email: '',
      password: '',
    };
  },

  methods: {
    submit() {
      this.step = '';

      if (!this.email) {
        return this.$nextTick(() => { this.step = 'email'; });
      }

      if (!this.password) {
        return this.$nextTick(() => { this.step = 'password'; });
      }

      return this.$emit('submit', {
        email: this.email,
        password: sanitizePassword(this.password),
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/forms/Login.vue